'use client';

import { atom } from 'jotai';

import { Tenant } from '../../Entities/App/Tenants.entity';

export const tenantAtom = atom<Tenant | undefined>(undefined);
